import ChangeTransactionCategorySettingsPopup from '../pages/responsive-pages/authenticated/navigation-pages/cashflow-app/cashflow-view/current-month/components/cashflow-edit/edit-transaction/ChangeTransactionCategorySettingsPopup.vue'; // eslint-disable-line
import MoveToFixedConfirmationPopup from '../pages/responsive-pages/authenticated/navigation-pages/cashflow-app/cashflow-view/current-month/components/cashflow-edit/edit-transaction/MoveToFixedConfirmationPopup.vue'; // eslint-disable-line
import MoveToExcludedConfirmationPopup from '../pages/responsive-pages/authenticated/navigation-pages/cashflow-app/cashflow-view/current-month/components/cashflow-edit/edit-transaction/MoveToExcludedConfirmationPopup.vue'; // eslint-disable-line
import MoveFromExcludedConfirmationPopup from '../pages/responsive-pages/authenticated/navigation-pages/cashflow-app/cashflow-view/current-month/components/cashflow-edit/edit-transaction/MoveFromExcludedConfirmationPopup.vue'; // eslint-disable-line
import MoveFromFixedConfirmationPopup from '../pages/responsive-pages/authenticated/navigation-pages/cashflow-app/cashflow-view/current-month/components/cashflow-edit/edit-transaction/MoveFromFixedConfirmationPopup'; // eslint-disable-line

const CATEGORY_NAMES = {
  RECURRING_ECONOMY: 'recurringEconomy',
  RECURRING_CAR: 'recurringCar',
  RECURRING_PHARMACY: 'recurringPharmacy',
  RECURRING_EATING_OUT: 'recurringEatingOut',
  RECURRING_PUBLIC_TRANSPORT: 'recurringPublicTransport',
  VARIABLE: 'variable',
  VARIABLE_INCOME: 'variableIncome',
  FIXED_EXPENSE: 'fixedExpense',
  FIXED_INCOME: 'fixedIncome',
  EXCLUDED_INCOME: 'excludedIncome',
  EXCLUDED_EXPENSE: 'excludedExpense',
  TRACKING: 'tracking',
};

const CASHFLOW_CATEGORIES = {
  VARIABLE: 'variable',
  FIXED: 'fixed',
  FIXED_INCOME: 'fixed-income',
  RECURRING: 'recurring',
  TRACKING: 'tracking',
  VARIABLE_INCOME: 'variable-income',
  EXCLUDED_INCOME: 'excluded-income',
  EXCLUDED_EXPENSE: 'excluded-expense',
};

const CATEGORY_STYLE = {
  [CASHFLOW_CATEGORIES.RECURRING]: 'primary',
  [CASHFLOW_CATEGORIES.TRACKING]: 'primary',
  [CASHFLOW_CATEGORIES.VARIABLE]: 'warning',
  [CASHFLOW_CATEGORIES.FIXED]: 'danger',
  [CASHFLOW_CATEGORIES.VARIABLE_INCOME]: 'success',
  [CASHFLOW_CATEGORIES.FIXED_INCOME]: 'success',
  [CASHFLOW_CATEGORIES.EXCLUDED_INCOME]: 'neutral',
  [CASHFLOW_CATEGORIES.EXCLUDED_EXPENSE]: 'neutral',
};

const TRANSFERABLE_FIXED_EXPENSE_CATEGORIES = [
  'ארנונה',
  'ביטוח',
  'ביטוח לאומי',
  'גז',
  'דיגיטל',
  'דיור',
  'הוצאה לפועל',
  'החזר טכני',
  'הלוואה',
  'חינוך',
  'חשמל',
  'כללי',
  'לחסכון',
  'מים',
  'מכירת ניירות ערך או מטח',
  'מס הכנסה',
  'משכנתא',
  'סיוע בשכר דירה',
  'עמלות',
  'קצבאות',
  'תקשורת',
  'אחר',
];

const NON_TRANSFERABLE_FIXED_EXPENSE_CATEGORIES = [
  'תשלומים',
  'העברות',
  'שיק',
  'מזומן',
];

export default {
  cashflowTypes: {
    income: 'income',
    car: 'car',
    economy: 'economy',
    fixedExpense: 'fixedExpense',
    variableExpense: 'variableExpense',
    excluded: 'excluded',
    riseupGoal: 'riseupGoal',
    recurring: 'recurring',
    trackingCategory: 'trackingCategory',
  },
  envelopeTimeFrames: {
    weekly: 'weekly',
    monthly: 'monthly',
  },
  weekTimeFrames: {
    past: 'past',
    current: 'current',
    future: 'future',
  },
  CATEGORIES: [
    { categoryName: CATEGORY_NAMES.RECURRING_ECONOMY, expense: 'כלכלה', cashflowCategory: CASHFLOW_CATEGORIES.RECURRING, icon: '🛒', label: 'חוזרת: סופר', pluralLabel: 'חוזרות: סופר', style: CATEGORY_STYLE[CASHFLOW_CATEGORIES.RECURRING], targetPopup: ChangeTransactionCategorySettingsPopup }, // eslint-disable-line
    { categoryName: CATEGORY_NAMES.RECURRING_CAR, expense: 'רכב', cashflowCategory: CASHFLOW_CATEGORIES.RECURRING, icon: '🚗', label: 'חוזרת: רכב', pluralLabel: 'חוזרות: רכב', style: CATEGORY_STYLE[CASHFLOW_CATEGORIES.RECURRING], targetPopup: ChangeTransactionCategorySettingsPopup }, // eslint-disable-line
    { categoryName: CATEGORY_NAMES.RECURRING_EATING_OUT, expense: 'אוכל בחוץ', cashflowCategory: CASHFLOW_CATEGORIES.RECURRING, icon: '🥤', label: 'חוזרת: אוכל בחוץ', pluralLabel: 'חוזרות: אוכל בחוץ', style: CATEGORY_STYLE[CASHFLOW_CATEGORIES.RECURRING], targetPopup: ChangeTransactionCategorySettingsPopup }, // eslint-disable-line
    { categoryName: CATEGORY_NAMES.RECURRING_PHARMACY, expense: 'פארמה', cashflowCategory: CASHFLOW_CATEGORIES.RECURRING, icon: '💊', label: 'חוזרת: פארמה', pluralLabel: 'חוזרות: פארמה', style: CATEGORY_STYLE[CASHFLOW_CATEGORIES.RECURRING], targetPopup: ChangeTransactionCategorySettingsPopup }, // eslint-disable-line
    { categoryName: CATEGORY_NAMES.RECURRING_PUBLIC_TRANSPORT, expense: 'תחבורה ציבורית', cashflowCategory: CASHFLOW_CATEGORIES.RECURRING, icon: '🚌', label: 'חוזרת: תחב"צ', pluralLabel: 'חוזרות: תחב"צ', style: CATEGORY_STYLE[CASHFLOW_CATEGORIES.RECURRING], targetPopup: ChangeTransactionCategorySettingsPopup }, // eslint-disable-line
    { categoryName: CATEGORY_NAMES.VARIABLE, expense: 'משתנות', cashflowCategory: CASHFLOW_CATEGORIES.VARIABLE, icon: '🤹‍', label: 'משתנה', pluralLabel: 'משתנות', style: CATEGORY_STYLE[CASHFLOW_CATEGORIES.VARIABLE], targetPopup: ChangeTransactionCategorySettingsPopup }, // eslint-disable-line
    { categoryName: CATEGORY_NAMES.VARIABLE_INCOME, expense: 'הכנסות משתנות', cashflowCategory: CASHFLOW_CATEGORIES.VARIABLE_INCOME, icon: '🤹‍', label: 'משתנה', pluralLabel: 'משתנות', style: CATEGORY_STYLE[CASHFLOW_CATEGORIES.VARIABLE_INCOME], targetPopup: ChangeTransactionCategorySettingsPopup }, // eslint-disable-line
    { categoryName: CATEGORY_NAMES.FIXED_EXPENSE, cashflowCategory: CASHFLOW_CATEGORIES.FIXED, icon: '📅‍', label: 'קבועה', pluralLabel: 'קבועות', style: CATEGORY_STYLE[CASHFLOW_CATEGORIES.FIXED], originalPopup: MoveFromFixedConfirmationPopup, targetPopup: MoveToFixedConfirmationPopup }, // eslint-disable-line
    { categoryName: CATEGORY_NAMES.FIXED_INCOME, cashflowCategory: CASHFLOW_CATEGORIES.FIXED_INCOME, icon: '📅‍', label: 'קבועה', pluralLabel: 'קבועות', style: CATEGORY_STYLE[CASHFLOW_CATEGORIES.FIXED_INCOME], originalPopup: MoveFromFixedConfirmationPopup, targetPopup: MoveToFixedConfirmationPopup }, // eslint-disable-line
    { categoryName: CATEGORY_NAMES.EXCLUDED_EXPENSE, cashflowCategory: CASHFLOW_CATEGORIES.EXCLUDED_EXPENSE, icon: '🚫', label: 'לא תזרימית', pluralLabel: 'לא תזרימיות', originalPopup: MoveFromExcludedConfirmationPopup, style: CATEGORY_STYLE[CASHFLOW_CATEGORIES.EXCLUDED_EXPENSE], targetPopup: MoveToExcludedConfirmationPopup }, // eslint-disable-line
    { categoryName: CATEGORY_NAMES.EXCLUDED_INCOME, cashflowCategory: CASHFLOW_CATEGORIES.EXCLUDED_INCOME, icon: '🚫', label: 'לא תזרימית', pluralLabel: 'לא תזרימיות', originalPopup: MoveFromExcludedConfirmationPopup, style: CATEGORY_STYLE[CASHFLOW_CATEGORIES.EXCLUDED_INCOME], targetPopup: MoveToExcludedConfirmationPopup }, // eslint-disable-line
  ],
  CATEGORY_NAMES,
  CASHFLOW_CATEGORIES,
  CATEGORY_STYLE,
  AVAILABLE_CASHFLOW_CATEGORIES: {
    [CASHFLOW_CATEGORIES.VARIABLE]: [
      CASHFLOW_CATEGORIES.VARIABLE,
      CASHFLOW_CATEGORIES.RECURRING,
      CASHFLOW_CATEGORIES.FIXED,
      CASHFLOW_CATEGORIES.EXCLUDED_EXPENSE,
      CASHFLOW_CATEGORIES.TRACKING,
    ],
    [CASHFLOW_CATEGORIES.FIXED]: [
      CASHFLOW_CATEGORIES.VARIABLE,
      CASHFLOW_CATEGORIES.FIXED,
      // todo: add EXCLUDED_EXPENSE
    ],
    [CASHFLOW_CATEGORIES.EXCLUDED_EXPENSE]: [
      CASHFLOW_CATEGORIES.EXCLUDED_EXPENSE,
      CASHFLOW_CATEGORIES.VARIABLE,
    ],
    [CASHFLOW_CATEGORIES.EXCLUDED_INCOME]: [
      CASHFLOW_CATEGORIES.EXCLUDED_INCOME,
      CASHFLOW_CATEGORIES.VARIABLE_INCOME,
    ],
    [CASHFLOW_CATEGORIES.RECURRING]: [
      CASHFLOW_CATEGORIES.VARIABLE,
      CASHFLOW_CATEGORIES.RECURRING,
      CASHFLOW_CATEGORIES.TRACKING,
    ],
    [CASHFLOW_CATEGORIES.TRACKING]: [
      CASHFLOW_CATEGORIES.VARIABLE,
      CASHFLOW_CATEGORIES.RECURRING,
      CASHFLOW_CATEGORIES.TRACKING,
    ],
    [CASHFLOW_CATEGORIES.VARIABLE_INCOME]: [
      CASHFLOW_CATEGORIES.VARIABLE_INCOME,
      CASHFLOW_CATEGORIES.FIXED_INCOME,
      CASHFLOW_CATEGORIES.EXCLUDED_INCOME,
    ],
    [CASHFLOW_CATEGORIES.FIXED_INCOME]: [
      CASHFLOW_CATEGORIES.VARIABLE_INCOME,
      CASHFLOW_CATEGORIES.FIXED_INCOME,
    ],
  },
  TRANSFERABLE_FIXED_EXPENSE_CATEGORIES,
  NON_TRANSFERABLE_FIXED_EXPENSE_CATEGORIES,
};
